// extracted by mini-css-extract-plugin
export default {"report":"DYavCUcoMOAf8SY_l5pm","loading":"VbowQrutRLK9FPDdLRHY"};